import React, { Component } from "react";
import ApiConnect from "../../../Utils/ApiConnect";
import { toast } from "react-toastify";
import moment from "moment";
import AutoComplete from "../../Components/AutoComplete";
export default class JournalVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: false,
      accountHeads: false,
      drAccount: false,
      crAccount: false,
      payment: false,
      crAmount: 0,
      drAmount: 0,
      narration: "",
      formError: false,
      previewImage: [],
      docs: [],
      btnDisable: false,
    };
  }
  componentDidMount() {
    this.fetchAccountDetails();
  }
  fetchAccountDetails() {
    ApiConnect.get("/Module/Accounts/AccountHead/Details")
      .then((response) => {
        this.setState({ accountHeads: response.data });
      })
      .catch((error) => console.log(error));
  }
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ docs: e.target.files, previewImage: fileArray });
    }
  }
  setSelectedAccount = (e) => {
    this.setState({ drAccount: e });
  };
  setSelectedAccount_2 = (e) => {
    if (this.state.drAccount.id !== e.id) {
      this.setState({ crAccount: e, btnDisable: false });
    } else {
      toast.error("Cannot Create Voucher with same Account", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
      this.setState({ btnDisable: true });
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("drAccount", this.state.drAccount.id);
    Fdatas.append("crAccount", this.state.crAccount.id);
    Fdatas.append("drAmount", this.state.drAmount);
    Fdatas.append("crAmount", this.state.crAmount);
    Fdatas.append("narration", this.state.narration);
    Fdatas.append(
      "date",
      this.state.date ? moment(this.state.date).format("Y-MM-DD") : ""
    );
    for (let i = 0; i < this.state.docs.length; i++) {
      Fdatas.append("images_files[]", this.state.docs[i]);
    }
    ApiConnect({
      method: "post",
      url: "/Module/Vouchers/Main/NewJournal",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            date: false,
            drAccount: false,
            crAccount: false,
            payment: false,
            crAmount: 0,
            drAmount: 0,
            narration: false,
            formError: false,
            previewImage: [],
            docs: [],
            btnDisable: false,
          });
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((err) => console.error(err));
  };
  render() {
    const AccountData_1 = this.state.drAccount;
    const AccountData_2 = this.state.crAccount;
    return (
      <div className="card">
        <div className="card-title">
          <div className="d-flex">
            <h5>Journal Voucher Entry</h5>
          </div>
        </div>
        <div className="card-body">
          <div className="row invoice-info bg-white">
            <div className="col-4 pb-3">
              <div className="row form-group">
                <div className="col">
                  <label>Date *</label>
                  <input
                    className="form-control"
                    type="date"
                    name="date"
                    onChange={(e) => this.setState({ date: e.target.value })}
                    defaultValue={this.state.date}
                  />
                </div>
              </div>
            </div>
            <div className="col-8 pb-3 row">
              <address className="col">
                Type: <strong>{AccountData_1.group || ""}</strong>
                <br />
                <b>Address: </b>
                {AccountData_1.address || ""}
                <br />
              </address>
              <address className="col">
                <b>Contact: </b> {AccountData_1.contact || ""}
                <br />
                <strong>Balance: {AccountData_1.balance || ""}/</strong>
                <br />
              </address>
              <address className="col">
                <b>Last Credit: </b>
                {AccountData_1.lastCredit || ""}
                <br />
                <b>Last Debit: </b>
                {AccountData_1.lastDebit || ""}
              </address>
            </div>
          </div>

          <form onSubmit={(e) => this.handleSubmit(e)}>
            <div className="col-xs-12">
              <p className="text-danger">{this.state.formError}</p>
              <table className="table table-separated table-sm">
                <thead>
                  <tr>
                    <th>Account Head</th>
                    <th>Description</th>
                    <th>Debit Amount</th>
                    <th>Credit Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="col-4">
                      {this.state.accountHeads && (
                        <AutoComplete
                          action={this.setSelectedAccount}
                          name="account_1"
                          // defaultFallback={this.ChangeProductStatus}
                          placeHolder="Account to be Debited"
                          items={this.state.accountHeads}
                        />
                      )}
                    </td>
                    <td className="col-4">
                      <address className="col">
                        <b>Last Credit: </b> {AccountData_1.lastCredit || ""}
                        <br />
                        <strong>
                          Balance:{" "}
                          {parseFloat(AccountData_1.balance) +
                            parseFloat(this.state.drAmount) || ""}
                          /
                        </strong>
                      </address>
                    </td>
                    <td className="col4">
                      <input
                        className="form-control"
                        type="number"
                        name="drAmount_1"
                        required
                        value={this.state.drAmount}
                        onChange={(e) =>
                          this.setState({
                            drAmount: e.target.value,
                            crAmount: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="col4"></td>
                  </tr>
                  {this.state.drAccount ? (
                    <tr>
                      <td className="col-4">
                        {this.state.accountHeads && (
                          <AutoComplete
                            action={this.setSelectedAccount_2}
                            name="account_2"
                            // defaultFallback={this.ChangeProductStatus}
                            placeHolder="Account to be Created"
                            items={this.state.accountHeads}
                          />
                        )}
                      </td>
                      <td className="col-4">
                        <address className="col">
                          <b>Last Credit: </b> {AccountData_2.lastCredit || ""}
                          <br />
                          <strong>
                            Balance:{" "}
                            {parseFloat(AccountData_2.balance) -
                              parseFloat(this.state.drAmount) || ""}
                            /
                          </strong>
                        </address>
                      </td>

                      <td className="col4"></td>
                      <td className="col4">
                        <input
                          className="form-control"
                          type="number"
                          name="crAmount_2"
                          required
                          value={this.state.drAmount}
                          disabled={true}
                        />
                      </td>
                    </tr>
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
              <div className="row">
                <div className="col-6 ">
                  <h6 className="mb-0 fw-bold py-3 ">Narrator</h6>
                  <textarea
                    className="form-control"
                    rows={3}
                    placeholder="Narrator"
                    name="notes"
                    value={this.state.narration}
                    onChange={(e) =>
                      this.setState({ narration: e.target.value })
                    }
                  />
                </div>
                <div className="col-6">
                  <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                    <h6 className="mb-0 fw-bold ">Images</h6>
                  </div>
                  <div className="card-body border-dark b-1 btn-out-dashed">
                    <div className="file-group">
                      <input
                        type="file"
                        id="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => this.imageHandleChange(e)}
                      />
                      <label htmlFor="file">
                        <span className="material-icons-outlined">
                          upload_file
                        </span>
                      </label>
                    </div>
                    <div className="row">
                      {this.state.previewImage.map((image, index) => (
                        <div className="col" key={index}>
                          <img
                            className="img-thumbnail"
                            width="150"
                            src={image}
                            alt={`document${index}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <footer className="card-footer">
                <button
                  className="btn btn-success w-100"
                  type="submit"
                  disabled={this.state.btnDisable}
                >
                  Submit Entries
                </button>
              </footer>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
